import { OSS_URL } from '../config';

export const FILE_URL = `${OSS_URL}/file`;
